import { useState, useEffect } from "react";
import Loading from "../../../components/UI/Loading/Loading";
import { useParams } from "react-router-dom";
import api, { authService } from "../../../services/api";
import { useNotification } from "../../../components/Notifications/NotificationContext";
import { useSyncBotSelection } from "../../../hooks/useSyncBotSelection";
import { validateButtons } from "../../../utils/buttonValidator";
import { validateFields } from "../../../utils/contentBlacklistValidator";
// import './index.css';

export default function Buttons() {
    const { botId } = useParams();
    const { showError, showSuccess } = useNotification();

    const [buttons, setButtons] = useState([]);
    const [loading, setLoading] = useState(false);
    const [loadingPage, setLoadingPage] = useState(true);

    useSyncBotSelection();

    // Carrega dados do bot ao inicializar
    useEffect(() => {
        if (!botId) return;
        loadButtonsData();
    }, [botId]);

    const loadButtonsData = async () => {
        try {
            setLoadingPage(true);
            const { data } = await authService.bots.edit_bot(botId);
            const bot = data.bot;

            // Carrega botões personalizados se existirem
            setButtons(
                Array.isArray(bot.buttons)
                    ? bot.buttons.map((btn) => ({
                        ...btn,
                        color: btn.color || 'default'
                    }))
                    : []
            );
        } catch (err) {
            console.error(err);
            showError("Erro ao carregar botões");
        } finally {
            setLoadingPage(false);
        }
    };

    const handleButtonChange = (index, field, value) => {
        const updatedButtons = [...buttons];
        updatedButtons[index][field] = value;
        setButtons(updatedButtons);
    };

    const addButton = () => {
        setButtons([...buttons, { text: "", url: "", color: "default" }]);
    };

    const removeButton = (index) => {
        setButtons(buttons.filter((_, i) => i !== index));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            // ✅ Validar botões personalizados
            const buttonValidation = validateButtons(buttons);
            if (!buttonValidation.isValid) {
                showError(buttonValidation.error);
                setLoading(false);
                return;
            }

            // ✅ Validar conteúdo proibido nos textos dos botões
            const contentCheck = validateFields(
                buttonValidation.validButtons.map((btn, index) => ({
                    label: `Botão ${index + 1}`,
                    value: btn.text,
                }))
            );
            if (!contentCheck.isValid) {
                showError(contentCheck.error);
                setLoading(false);
                return;
            }

            // Preparar dados
            const botData = {
                buttons: buttonValidation.validButtons
            };

            // Atualizar dados do bot
            const { data: response } = await authService.bots.edit_bot_submit(botId, botData);

            if (!response.success) {
                throw new Error(response.error || "Erro ao atualizar botões");
            }

            showSuccess("Botões atualizados com sucesso!");
            loadButtonsData();
        } catch (err) {
            console.error(err);
            const errorMsg = err?.response?.data?.error || err?.message || "Erro ao salvar botões";
            showError(errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            {loadingPage ? (
                <Loading text="Carregando Botões..." />
            ) : (
                <form onSubmit={handleSubmit} style={{ opacity: loading ? 0.6 : 1, pointerEvents: loading ? 'none' : 'auto' }}>
                    <div className="spt-form-bot">
                        <div className="mt-4">
                            <label className="spt-label">Botões Personalizados</label>

                            <div className="form-hint">
                                Adicione botões com texto (máx. 64 caracteres) e link (máx. 200 caracteres) para grupos, usuários ou sites.
                                URLs devem começar com https:// ou t.me/. Deixe vazio se não quiser botões.
                            </div>

                            <div className="sx-desktop-forms mt-4">
                                <table className="sx-table">
                                    <thead>
                                        <tr>
                                            <th>Texto</th>
                                            <th>Link</th>
                                            <th>Cor</th>
                                            <th>Ação</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {buttons.length > 0 ? (
                                            buttons.map((button, index) => (
                                                <tr key={index}>
                                                    <td>
                                                        <input
                                                            placeholder="Texto do botão"
                                                            value={button.text}
                                                            onChange={(e) => handleButtonChange(index, 'text', e.target.value)}
                                                            className="input3"
                                                            maxLength={64}
                                                        />
                                                        {button.text && button.text.length > 50 && (
                                                            <small className="text-yellow-500 text-xs">{button.text.length}/64</small>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <input
                                                            placeholder="https://t.me/grupogratis"
                                                            value={button.url}
                                                            onChange={(e) => handleButtonChange(index, 'url', e.target.value)}
                                                            className="input3"
                                                            maxLength={200}
                                                        />
                                                        {button.url && button.url.length > 180 && (
                                                            <small className="text-yellow-500 text-xs">{button.url.length}/200</small>
                                                        )}
                                                    </td>
                                                    <td>
                                                        {/* <select
                                                            value={button.color || "default"}
                                                            onChange={(e) => handleButtonChange(index, 'color', e.target.value)}
                                                            className="form-select"
                                                        >
                                                            <option value="default" className="btn-secondary">Padrao</option>
                                                            <option value="green">Verde</option>
                                                            <option value="red">Vermelho</option>
                                                            <option value="blue">Azul</option>
                                                        </select> */}
                                                        <div className="mx-auto w-max flex gap-1 md:m-0">
                                                            {[
                                                                { label: "Padrão", value: "default", class: "bg-gray-600" },
                                                                { label: "Verde", value: "green", class: "bg-green-600" },
                                                                { label: "Vermelho", value: "red", class: "bg-red-600" },
                                                                { label: "Azul", value: "blue", class: "bg-blue-600" },
                                                            ].map((colorOption) => (
                                                                <button
                                                                    key={colorOption.value}
                                                                    type="button"
                                                                    onClick={() =>
                                                                        handleButtonChange(index, "color", colorOption.value)
                                                                    }
                                                                    className={`
                                                                            px-3 py-1 rounded text-white border-2 transition-all
                                                                            ${colorOption.class}
                                                                            ${button.color === colorOption.value
                                                                            ? "border-gray-400 scale-110 mx-2"
                                                                            : "border-transparent scale-90 opacity-90"
                                                                        }`}
                                                                >
                                                                    {colorOption.label}
                                                                </button>
                                                            ))}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            className="btn-delete"
                                                            onClick={() => removeButton(index)}
                                                        >
                                                            <i className="fas fa-trash"></i>
                                                            Remover
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" className="text-center py-8 text-gray-500">
                                                    Nenhum botão configurado. Clique em "Adicionar Botão" para começar.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <div className="flex justify-center mt-8">
                                    <button
                                        type="button"
                                        className="btn-primary"
                                        onClick={addButton}
                                    >
                                        <i className="fas fa-plus me-2"></i> Adicionar Botão
                                    </button>
                                </div>
                            </div>
                        </div>


                        <div className="flex justify-end mt-8">
                            <button
                                type="submit"
                                disabled={loading}
                                className="btn-primary"
                            >
                                {loading ? (
                                    <><i className="fas fa-spinner fa-spin me-2"></i> Salvando...</>
                                ) : (
                                    <><i className="fas fa-save me-2"></i> Salvar Botões</>
                                )}
                            </button>
                        </div>
                    </div>

                    <div className="info-card mt-8">
                        <p>
                            <i className="fas fa-info-circle"></i>
                            Estes botões aparecerão apenas na mensagem de <strong>Boas-vindas</strong>.
                        </p>
                    </div>
                </form>


            )}
        </>
    );
}
